<template>
  <div class="container">
    <div class="mt-2 card">
      <PatientInfo v-if="patient_id != null" :patient_id="patient_id">
        <template v-slot:action-bt>
          <button
            @click="showCreatePatientService"
            class="mycustom-success-button"
          >
            Add Test 
          </button>
        </template>
      </PatientInfo>
    </div>
  </div>
  <div v-if="loading">
    <loader />
  </div>
  <div v-if="!loading" class="container">
    <div class="mt-2 card">
      <table class="table align-items-center mb-0">
        <thead>
          <tr style="color: black">
            <th scope="col">Test Number</th>
            <th scope="col">Test Name</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="service in services" :key="service.id">
            <th scope="row">{{ service.id }}</th>
            <td style="color: black">{{ service.service_name }}</td>
            <td>
              <!-- {{
                service.attended == "0" || service.attended == null
                  ? "Pending..."
                  : service.attended == "1"
                  ? "Attended"
                  : "--"
              }} -->
                  <!-- {{ service.attended  }} -->
              <span v-if="service.attended == '0' || service.attended == null"
                >Pending...</span
              >
              <span v-if="service.attended == '1' || service.attended == 1"
                >Ongoing...</span
              >
              <span v-if="service.attended == '2' || service.attended == 2"
                >Completed</span
              >
            </td>
            <td>
              <a
                v-if="
                  open_service(
                    service.is_invoice,
                    service.is_paid,
                    cash_bills_behavior
                  )
                "
                :href="'/lab-details/' + service.id"
                class="btn btn-sm btn-info button-touch"
              >
                Details</a
              >.
              <span
                v-if="
                  !open_service(
                    service.is_invoice,
                    service.is_paid,
                    cash_bills_behavior
                  )
                "
                style="
                  color: black;
                  background-color: pink;
                  padding: 1px;
                  margin: 2px;
                "
              >
                !! Pending Payment !!
              </span>
              <!-- <button
                class="btn btn-sm btn-secondary button-touch"
                v-if="service.attended != 1"
                @click="handleShowAddTestModal(service.id)"
              >
                Conduct</button
              >. -->
              <button
                class="btn btn-sm btn-danger button-touch"
                v-if="service.attended != 1"
                @click="removeTest(service.id)"
              >
                <!-- <i class="fa fa-pen" aria-hidden="true"></i> -->
                Delete Test
              </button>

              <!-- <button
                class="btn btn-sm btn-primary button-touch"
                v-if="service.attended == 1"
                @click="editTest(service.id)"
              >
                Edit Test</button
              >. -->
              <!-- <button
                @click="showViewTestModal(service.id)"
                class="btn btn-sm btn-info button-touch"
                v-if="service.attended == 1"
              >
                View
              </button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <ConductLabtestModal
    v-if="show_add_lab_test_modal"
    @hide-create-test-model="hideCreateTestModel"
    :service_id="current_test"
  />

  <CreateServiceModal
    v-if="showAddServiceModal"
    :visitId="visit_id"
    @close-add-service-modal="showAddServiceModal = false"
  />

  <ViewLabResults
    v-if="showViewModal"
    :service_id="current_test"
    @close-view-result-modal="showViewModal = false"
  />
</template>

<script>
import PatientInfo from "../Patients/components/patient_biodata.vue";
import CreateServiceModal from "./add_patient_service_modal.vue";
import ConductLabtestModal from "./lab/add_lab_test_modal.vue";
import { generalApiRequest } from "../../api/apiIndex.js";
import ViewLabResults from "./lab/view_lab_results.vue";
import { get_setting } from "../../settings/get_setting.js";
import loader from "../special_clinics/dialysis/loader.vue";
import { open_service } from "../../settings/get_setting.js";

export default {
  name: "VisitsDashboard",
  data() {
    return {
      show_add_lab_test_modal: false,
      visit_id: this.$route.params.visitid,
      patient_id: null,
      showAddServiceModal: false,
      services: [], // Stores services for the current visit
      current_test: "",
      showViewModal: false,
      cash_bills_behavior: 0,
      loading: false,
    };
  },
  components: {
    ConductLabtestModal,
    PatientInfo,
    CreateServiceModal,
    ViewLabResults,
    loader,
  },
  methods: {
    open_service,
    navigate_loc(route) {
      window.location.href = route;
    },
    showViewTestModal(tid) {
      this.current_test = tid;
      this.showViewModal = true;
    },

    handleShowAddTestModal(tid) {
      this.current_test = tid;
      this.show_add_lab_test_modal = true;
      // You can pass the service info to the modal if needed
    },

    hideCreateTestModel() {
      this.show_add_lab_test_modal = false;
      window.location.reload();
    },

    showCreatePatientService() {
      this.showAddServiceModal = true;
    },

    async fetchServicesForVisit() {
      this.loading = true;
      const url = `services/for-visit/${this.visit_id}/2`;
      try {
        const response = await generalApiRequest(url, "GET", {}, 1);
        // console.log(response);

        this.services = response.data;

        const payment_setting = await get_setting("cash_bills_behavior");
        this.cash_bills_behavior = payment_setting.setting_value;
      } catch (error) {
        console.error("Error fetching services:", error);
      }
      this.loading = false;
    },

    async removeTest(serviceId) {
      const url = "services/delete/" + serviceId;
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      if (res) {
        location.reload();
      }
    },

    editTest(serviceId) {
      this.current_test = serviceId;
      this.show_add_lab_test_modal = true;
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const body = { visit_id: this.visit_id };
      const res = await generalApiRequest(url, "GET", body, 1);
      this.past_records = res.data;
      console.log(res.data);

      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },
  },

  mounted() {
    this.mountPastRecords();
    this.fetchServicesForVisit(); // Fetch services when the component is mounted
  },
};
</script>

<style scoped>
td,
th {
  text-align: center;
  vertical-align: middle;
  padding: 8px;
  border-top: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  word-wrap: break-word;
}

td {
  padding: 8px;
  border: 1px solid #ddd;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  font-size: 16px;
  overflow: hidden;
}

@media (max-width: 768px) {
  td {
    font-size: 12px;
    padding: 6px;
  }
}

@media (max-width: 480px) {
  td {
    font-size: 10px;
    padding: 4px;
  }

  table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .button-touch {
    margin-bottom: 0;
    padding-left: 0.9em;
    padding-top: 0.3em;
    padding-bottom: 0.3em;
    padding-right: 0.7em;
    font-size: 1.2em;
  }
}
</style>
